import gql from 'graphql-tag'
import { DOCTOR_FRAGMENTS } from '@medical/layout/DoctorLayout/DoctorLayoutRequest.graphql'

export const GET_MY_CAR_COMMUTING_APPLICATION = gql`
  query GET_MY_CAR_COMMUTING_APPLICATION {
    doctorMe {
      ...DOCTOR_FRAGMENTS
      myCarCommutingApplication {
        id
        frontSideLicenseKey
        backSideLicenseKey
        expirationDate
        vehicleInspectionCertificateKey
        liabilityInsuranceCertificateKey
        voluntaryInsuranceCertificateKey
        vehicleInspectionExpirationDate
        vehicleType
        licensePlateNumberPart1
        licensePlateNumberPart2
        licensePlateNumberPart3
        licensePlateNumberPart4
        isAgreedToRegulations
        approvalStatus
        staffComment
        carCommuteStartDate
        liabilityInsuranceCertificateExpirationDate
        voluntaryInsuranceCertificateExpirationDate
      }
    }
  }
  ${DOCTOR_FRAGMENTS}
`

export const CREATE_MY_CAR_COMMUTING_APPLICATION = gql`
  mutation CREATE_MY_CAR_COMMUTING_APPLICATION(
    $frontSideLicenseKey: String!
    $backSideLicenseKey: String!
    $expirationDate: DateTime!
    $carCommuteStartDate: DateTime!
    $voluntaryInsuranceCertificateExpirationDate: DateTime!
    $liabilityInsuranceCertificateExpirationDate: DateTime!
    $vehicleInspectionCertificateKey: String!
    $liabilityInsuranceCertificateKey: String!
    $voluntaryInsuranceCertificateKey: String!
    $vehicleInspectionExpirationDate: DateTime!
    $vehicleType: String!
    $licensePlateNumberPart1: String!
    $licensePlateNumberPart2: String!
    $licensePlateNumberPart3: String!
    $licensePlateNumberPart4: String!
    $isAgreedToRegulations: Boolean!
  ) {
    createMyCarCommutingApplication(
      frontSideLicenseKey: $frontSideLicenseKey
      backSideLicenseKey: $backSideLicenseKey
      expirationDate: $expirationDate
      carCommuteStartDate: $carCommuteStartDate
      vehicleInspectionCertificateKey: $vehicleInspectionCertificateKey
      liabilityInsuranceCertificateKey: $liabilityInsuranceCertificateKey
      voluntaryInsuranceCertificateKey: $voluntaryInsuranceCertificateKey
      vehicleInspectionExpirationDate: $vehicleInspectionExpirationDate
      voluntaryInsuranceCertificateExpirationDate: $voluntaryInsuranceCertificateExpirationDate
      liabilityInsuranceCertificateExpirationDate: $liabilityInsuranceCertificateExpirationDate
      vehicleType: $vehicleType
      licensePlateNumberPart1: $licensePlateNumberPart1
      licensePlateNumberPart2: $licensePlateNumberPart2
      licensePlateNumberPart3: $licensePlateNumberPart3
      licensePlateNumberPart4: $licensePlateNumberPart4
      isAgreedToRegulations: $isAgreedToRegulations
    ) {
      id
      frontSideLicenseKey
      backSideLicenseKey
      expirationDate
      carCommuteStartDate
      vehicleInspectionCertificateKey
      liabilityInsuranceCertificateKey
      voluntaryInsuranceCertificateKey
      vehicleInspectionExpirationDate
      vehicleType
      licensePlateNumberPart1
      licensePlateNumberPart2
      licensePlateNumberPart3
      licensePlateNumberPart4
      isAgreedToRegulations
      voluntaryInsuranceCertificateExpirationDate
      liabilityInsuranceCertificateExpirationDate
    }
  }
`

